/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
    'use strict';

    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    enum EntityTypeEnum {
        category,
        service
    }

    enum ToggleEnum {
        selected,
        deselected
    }

    export enum ServicesStatusEnum {
        Active,
        Inactive,
        Both
    }

    interface IServiceCategory {
        displayName: string,
        id: Guid,
        selected?: boolean
    }

    interface IService {
        displayName: string,
        id: Guid,
        selected?: boolean,
        disabled?: boolean,
        objectState: ObjectStateEnum
    }

    interface IServiceMoverController {
        // list of categories
        serviceCategories: Array<IServiceCategory>;
        // two models for selected and not-selected categories
        serviceCategoriesSelection: Array<IServiceCategory>;
        selectedServiceCategoriesSelection: Array<IServiceCategory>;

        // list of services
        services: Array<IService>;
        // two models for selected and not-selected services
        servicesSelection: Array<IService>;
        selectedServicesSelection: Array<IService>;

        ngModel: angular.INgModelController;
        // comes from directive
        categories: Array<Guid>;
        centralOffice: boolean;
        hierarchyBusinessType: Guid | string;
        hierarchyId: string;
        hierarchyBranchItem: string;
        hierarchyLocationList: Array<any>;
        disabled: boolean; // disabled by hierarchy
        securityDisabled: boolean;
        fullResponse: boolean;
        nullIfEmpty: boolean;

        fetching: boolean;

        servicesStatus: ServicesStatusEnum;

        initModelValue: any;
        isAllServicesCategoriesSelected: boolean;
        isAllServicesSelected: boolean;
        hierarchyCriteria: Object;
        categoriesCanceller: ng.IDeferred<any>;
        servicesCanceller: ng.IDeferred<any>;

        init(): void;
        setHierarchyWatchers(): void;
        createHierarchyCriteria(newVal: any, oldVal: any): void;
        select(entityType: EntityTypeEnum): void;
        deselect(entityType: EntityTypeEnum): void;
        toggleAll(toggle: ToggleEnum, entityType: EntityTypeEnum): void;
        getSelected(entityType: EntityTypeEnum): Array<any>;
        getFilteredServices(): Array<IService>;
        checkEntitiesSpecificType(toggle: ToggleEnum, entityType: EntityTypeEnum): boolean;
        isCategoriesSelected(): boolean;
        getServicesByCategories(): void;
        setModelValue(isAlreadyFiltered: boolean): void;
        filterServicesByStatus(isChangedManually: boolean): void;
        getCategories(): ng.IPromise<any>;
        checkAllCallback(entityType: EntityTypeEnum): void;
    }

    export class ServiceMoverController implements IServiceMoverController {
        serviceCategories: Array<IServiceCategory> = [];
        serviceCategoriesSelection: Array<IServiceCategory> = [];
        selectedServiceCategoriesSelection: Array<IServiceCategory> = [];

        services: Array<IService> = [];
        servicesSelection: Array<IService> = [];
        selectedServicesSelection: Array<IService> = [];

        ngModel: angular.INgModelController;
        categories: Array<Guid>;
        centralOffice: boolean;
        hierarchyBusinessType: Guid | string;
        hierarchyId: string;
        hierarchyBranchItem: string;
        hierarchyLocationList: Array<any>;
        disabled: boolean;
        securityDisabled: boolean = false;
        fullResponse: boolean;
        nullIfEmpty: boolean;

        fetching: boolean = false;

        servicesStatus: ServicesStatusEnum = ServicesStatusEnum.Active;

        initModelValue = [];
        isAllServicesCategoriesSelected: boolean;
        isAllServicesSelected: boolean;
        hierarchyCriteria: Object = {};
        categoriesCanceller: ng.IDeferred<any> = null;
        servicesCanceller: ng.IDeferred<any> = null;

        private _statusList = {
            'LABEL_ACTIVE': ServicesStatusEnum.Active,
            'LABEL_INACTIVE': ServicesStatusEnum.Inactive,
            'LABEL_BOTH': ServicesStatusEnum.Both
        };

        static $inject = [
            '$scope',
            '$q',
            'meevo.components.common.DataService',
            'meevo.components.busy.BusyService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            '$timeout'
        ];

        get modelViewValue(): any[] {
            let value = this.ngModel.$viewValue;

            return value === null || !value ? [] : value;
        }

        constructor(protected $scope: angular.IScope,
                    protected $q: ng.IQService,
                    protected dataService: Meevo.Components.BaseClasses.IDataService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    protected identityService: Meevo.Components.Common.IIdentityService,
                    protected $timeout: ng.ITimeoutService) {
        }

        /**
         * Function to be called when directive is initialized
         */
        init(): void {
            this.$timeout(() => {
                if (!angular.isDefined(this.ngModel.$viewValue)) {
                    this.ngModel.$setViewValue(this.initModelValue);
                }
            });

            if (!angular.isUndefined(this.nullIfEmpty)) {
                this.nullIfEmpty = false;
            }

            if (!angular.isDefined(this.categories)) {
                this.categories = this.initModelValue;
            }

            if (!angular.isDefined(this.fullResponse)) {
                this.fullResponse = false;
            }

            if (!angular.isDefined(this.isAllServicesCategoriesSelected)) {
                this.isAllServicesCategoriesSelected = true;
            }

            if (!angular.isDefined(this.isAllServicesSelected)) {
                this.isAllServicesSelected = true;
            }

            this.hierarchyCriteria = {
                businessTypeList: [this.identityService.businessTypeId],
                locationList: [this.identityService.locationId],
                hierarchyId: null,
                branchId: null
            };

            if (this.centralOffice) {
                this.setHierarchyWatchers();
            }

            if (!this.isAllServicesCategoriesSelected) {
                this.getCategories(false).then(() => {
                    if (!this.isAllServicesSelected) {
                        this.getServicesByCategories()
                    }
                });
            }
            // todo: prepopulating currently doesn't work with these "all" boxes
        }

        /**
         * Set watchers on Hierarchy control's variables in CO mode
         */
        setHierarchyWatchers(): void {
            this.$scope.$watch(() => this.hierarchyBusinessType, this.createHierarchyCriteria.bind(this));
            this.$scope.$watch(() => this.hierarchyId, this.createHierarchyCriteria.bind(this));
            this.$scope.$watch(() => this.hierarchyBranchItem, this.createHierarchyCriteria.bind(this));
            this.$scope.$watch(() => this.hierarchyLocationList, this.createHierarchyCriteria.bind(this), true);
        }

        /**
         * Create hierarchy criteria for getting services and categories
         * @param {any} newValue
         * @param {any} oldValue
         */
        createHierarchyCriteria(newValue, oldValue): void {
            if (!angular.isDefined(newValue) || angular.equals(newValue, oldValue)) return;

            // allow to use hierarchyId and branchId only in pair
            if ((this.hierarchyId && !this.hierarchyBranchItem) || (!this.hierarchyId && this.hierarchyBranchItem)) return;

            this.hierarchyCriteria = {
                businessTypeList: this.hierarchyBusinessType,
                locationList: this.hierarchyLocationList,
                hierarchyId: this.hierarchyId,
                branchId: this.hierarchyBranchItem
            };

            this.servicesStatus = ServicesStatusEnum.Active;
            if (this.isAllServicesCategoriesSelected) {
                this.categories = this.initModelValue;
            } else {
                if (this.isAllServicesSelected) {
                    this.getCategories();
                } else {
                    this.getCategories().then(() => {
                        this.getServicesByCategories();
                    });
                }
            }

            if (this.isAllServicesSelected) {
                this.ngModel.$setViewValue(this.initModelValue);
            } else {
                if (this.isAllServicesCategoriesSelected) {
                    this.getServicesByCategories();
                }
            }
        }

        /**
         * Select category or service
         */
        select(entityType: EntityTypeEnum = EntityTypeEnum.category): void {
            if (entityType === EntityTypeEnum.category) {

                if (this.serviceCategories.filter((category: IServiceCategory) => category.selected).length === 0) {
                    this.services = [];
                }

                this.serviceCategoriesSelection.forEach((category: IServiceCategory) => {
                    category.selected = true;
                });

                if (!this.isAllServicesSelected) {
                    this.getServicesByCategories();
                }
            } else if (entityType === EntityTypeEnum.service) {
                this.servicesSelection.forEach((service: IService) => {
                    service.selected = true;
                });
            }
            this.setModelValue();
        }

        /**
         * Deselect category or service
         */
        deselect(entityType: EntityTypeEnum = EntityTypeEnum.category): void {
            if (entityType === EntityTypeEnum.category) {
                this.selectedServiceCategoriesSelection.forEach((category: IServiceCategory) => {
                    category.selected = false;
                });

                if (this.serviceCategories.filter((category: IServiceCategory) => category.selected).length === 0) {
                    this.services = [];
                }

                if (!this.isAllServicesSelected) {
                    this.getServicesByCategories();
                }
            } else if (entityType === EntityTypeEnum.service) {
                this.selectedServicesSelection.forEach((service: IService) => {
                    service.selected = false;
                });
            }
            this.setModelValue();
        }

        /**
         * Select or deselect all categories or Services in one time
         * @param {EntityTypeEnum} entityType
         * @param {ToggleEnum} toggle
         */
        toggleAll(toggle: ToggleEnum, entityType: EntityTypeEnum = EntityTypeEnum.category): void {
            let selected = toggle === ToggleEnum.selected;

            if (entityType === EntityTypeEnum.category) {
                if (selected) { // select all that left
                    if (this.serviceCategories.filter((category: IServiceCategory) => category.selected).length === 0) {
                        this.services = [];
                    }
                } else { // deselect all
                    this.services = [];
                }

                this.serviceCategories.forEach((category: IServiceCategory) => {
                    category.selected = selected;
                });

                if (!this.isAllServicesSelected) {
                    this.getServicesByCategories();
                }
            } else if (entityType === EntityTypeEnum.service) {
                this.services.forEach((service: IService) => {
                    service.selected = selected;
                });
            }
            this.setModelValue();

        }

        /**
         * Get selected items from Categories or Services
         * @param {EntityTypeEnum} entityType
         * @returns {Array} any
         */
        getSelected(entityType: EntityTypeEnum): Array<any> {
            let data: Array<any> = [];

            if (entityType === EntityTypeEnum.category) {
                data = this.serviceCategories.filter((category: IServiceCategory) => category.selected);
            } else if (entityType === EntityTypeEnum.service) {
                data = this.services.filter((service: IService) => service.selected && !service.disabled);
            }
            return data;
        }

        /**
         * Get services filtered by selected status
         */
        getFilteredServices(): Array<IService> {
            return this.services.filter((service: IService) => !service.disabled);
        }

        /**
         * Check if all or no categories or services are selected
         * @param {ToggleEnum} toggle
         * @param {EntityTypeEnum} entityType
         * @returns {boolean}
         */
        checkEntitiesSpecificType(toggle: ToggleEnum, entityType: EntityTypeEnum = EntityTypeEnum.category): boolean {
            let selected = toggle === ToggleEnum.selected;

            if (entityType === EntityTypeEnum.category) {
                return this.serviceCategories.every((category: IServiceCategory) => category.selected === selected);
            } else if (entityType === EntityTypeEnum.service) {
                return this.getFilteredServices().every((service: IService) => service.selected === selected);
            }
        }

        /**
         * Check if at least one category is selected
         * @returns {boolean}
         */
        isCategoriesSelected(): boolean {
            return this.serviceCategories.some((category: IServiceCategory) => category.selected);
        }

        /**
         * Get all services by selected categories
         * @param {boolean} isInitialMode
         */
        getServicesByCategories(isInitialMode: boolean = false): ng.IPromise<void> {
            let serviceCategoryList: Array<any> = this.serviceCategories.filter((category: IServiceCategory) => category.selected)
                    .map((category: IServiceCategory) => category.id),
                criteria: Object = angular.extend(this.hierarchyCriteria, {
                    serviceCategoryList: serviceCategoryList,
                    objectStateEnumList: [ObjectStateEnum.Active, ObjectStateEnum.Inactive],
                    genderEnumList: [92, 93, 94, 2035],
                    displayName: null,
                    fieldOrderBy: 'DisplayName',
                    orderAscDesc: 'Ascending'
                });

            if (this.servicesCanceller) {
                this.servicesCanceller.resolve();
            }
            this.servicesCanceller = this.$q.defer();

            this.busyService.start();
            return this.dataService.getListPaged('Report/Service', {criteria}, null, null, {
                timeout: this.servicesCanceller.promise
            })
                .then((services: Array<IService> | any) => {
                    if (services === null) return;

                    this.services = (<IService[]>services).map((service: any) => {
                        return angular.merge(service, {
                            selected: (<any[]>this.modelViewValue)
                                .some(serviceId => {
                                    if (typeof serviceId === 'string') {
                                        return serviceId === (<string>service.id);
                                    }

                                    return (<IService>serviceId).id === service.id;
                                })
                        })
                    });

                    this.setModelValue();
                })
                .finally(() => {
                    this.busyService.stop();
                    this.servicesCanceller = null;
                });
        }

        /**
         * Set model value
         * @param {boolean} isAlreadyFiltered
         */
        setModelValue(isAlreadyFiltered?: boolean): void {
            if (!isAlreadyFiltered) {
                this.filterServicesByStatus();
            }

            let selectedServices = this.fullResponse ?
                this.getSelected(EntityTypeEnum.service) :
                this.getSelected(EntityTypeEnum.service).map((service: IService) => service.id);

            let selectedCategories = this.getSelected(EntityTypeEnum.category).map((caterory: IServiceCategory) => caterory.id);

            // send initModelValue if we don't have any available services by selected category and status
            if (selectedServices.length > 0 && selectedServices.length !== this.services.length && !this.isAllServicesSelected) {
                this.ngModel.$setViewValue(selectedServices);
            } else if (this.nullIfEmpty && selectedServices.length === 0 && !this.isAllServicesSelected) {
                this.ngModel.$setViewValue(null);
            } else {
                console.log(this.initModelValue);
                this.ngModel.$setViewValue(this.initModelValue);
                console.log(this.ngModel.$viewValue);

            }

            this.categories = selectedCategories.length > 0 && selectedCategories.length !== this.serviceCategories.length ? selectedCategories : this.initModelValue;
        }

        /**
         * Filter services by selected status
         * @param {boolean} isChangedManually
         */
        filterServicesByStatus(isChangedManually?: boolean): void {
            if (this.servicesStatus === ServicesStatusEnum.Both) {
                this.services.forEach((service: IService) => {
                    service.disabled = false;
                });
            } else {
                let disabledState = this.servicesStatus === ServicesStatusEnum.Active;

                this.services.forEach((service: IService) => {
                    if (service.objectState === ObjectStateEnum.Inactive) {
                        service.disabled = disabledState;
                    } else if (service.objectState === ObjectStateEnum.Active) {
                        service.disabled = !disabledState;
                    }
                });
            }

            if (isChangedManually) {
                this.setModelValue(true);
            }
        }

        /**
         * Get list of categories
         */
        getCategories(updateModelValue: boolean = true): ng.IPromise<any> {
            let criteria: Object = angular.extend(this.hierarchyCriteria, {
                objectStateEnumList: [ObjectStateEnum.Active],
                genderEnumList: [92, 93, 94, 2035],
                displayName: null,
                fieldOrderBy: 'DisplayName',
                orderAscDesc: 'Ascending'
            });

            if (this.categoriesCanceller) {
                this.categoriesCanceller.resolve();
            }

            this.categoriesCanceller = this.$q.defer();

            this.fetching = true;
            return this.dataService.getListPaged('Report/ServiceCategory', {criteria}, null, null, {
                timeout: this.categoriesCanceller.promise
            })
                .then((categories: Array<IServiceCategory> | any) => {
                    if (categories === null) return;

                    this.serviceCategories = (<IServiceCategory[]>categories).map(category => {

                        return angular.extend(category, {
                            selected: this.categories.some(catId => catId === category.id)
                        })
                    });

                    if (updateModelValue) {
                        this.setModelValue();
                    }
                })
                .finally(() => {
                    this.fetching = false;
                    this.categoriesCanceller = null;
                })
        }

        /**
         * User checks/unchecks 'All Service Categories' or 'All Services' checkbox
         * @param {EntityTypeEnum} entityType
         */
        checkAllCallback(entityType: EntityTypeEnum) {
            if (entityType === EntityTypeEnum.category) {
                if (this.isAllServicesCategoriesSelected) {
                    this.serviceCategories = this.initModelValue;
                    this.setModelValue();
                    this.getServicesByCategories();
                } else {
                    this.getCategories()
                        .finally(() => this.getServicesByCategories());
                }
            } else if (entityType === EntityTypeEnum.service) {
                if (this.isAllServicesSelected) {
                    this.services = this.initModelValue;
                    this.setModelValue();
                } else {
                    this.getServicesByCategories();
                }
            }
        }

        get toggleEnum(): any {
            return ToggleEnum;
        }

        get entityTypeEnum(): typeof EntityTypeEnum {
            return EntityTypeEnum;
        }

        get statusList(): any {
            return this._statusList;
        }
    }
}